import axios from 'axios';
import { panelRoot } from 'constants/defaultValues';
import { CustomToast, getCurrentUser } from 'helpers/Utils';

// axios.defaults.baseURL = "https://mukeb-de/api/";
// axios.defaults.baseURL = "https://mukebapi.barayeali.ir/api/";

console.log({ f: process.env.REACT_APP_API_URL });

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

axios.defaults.headers = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
};

axios.interceptors.request.use(
  function (request) {
    const user = getCurrentUser();
    if (user != null && user) {
      const { token } = user;
      request.headers.Authorization = `Bearer ${token}`;
    }
    return request;
  },
  function (error) {
    return Promise.reject(error);
  }
);
axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error?.response?.status == 403) {
      const data = error?.response?.data;
      // CustomToast(data?.message, 'عملیات غیر مجاز', 'error');

      localStorage.removeItem('user');
      window.location.href = panelRoot;

      CustomToast(
        data?.message,
        'شما دسترسی لازم برای انجام عملیات را ندارید',
        'error'
      );
    }

    return Promise.reject(error);
  }
);
export default axios;
